import { TCurrency } from '@/components/catalogue/types'

export function CurrencyToggle({
  currency,
  onCurrencyToggle,
}: {
  currency?: TCurrency
  onCurrencyToggle?: (currency: TCurrency) => void
}) {
  const checked = currency === 'USD'

  return (
    <label
      className="relative inline-block h-[24px] w-[50px] text-[13px]"
      role="button"
    >
      <input
        type="checkbox"
        className="peer h-[0] w-[0] opacity-0"
        checked={checked}
        onChange={() => {
          if (checked) {
            onCurrencyToggle?.('INR')
          } else {
            onCurrencyToggle?.('USD')
          }
        }}
      />
      <span className="bg-brand-grey-background peer-checked:bg-brand-grey-background before:bg-brand-blue-azureRadiance absolute bottom-0 left-0 right-0 top-0 cursor-pointer rounded-full before:absolute before:bottom-0 before:left-0 before:h-[24px] before:w-[24px] before:transform before:rounded-full before:transition-transform before:duration-300 before:content-[''] peer-checked:before:translate-x-[26px]" />

      <span className="text-brand-grey-base absolute right-[8px] top-1 transition-colors duration-300 peer-checked:text-white">
        $
      </span>
      <span className="peer-checked:text-brand-grey-base absolute left-2 top-1 text-white transition-colors duration-300">
        ₹
      </span>
    </label>
  )
}
